import React, { useState, useEffect, useRef } from "react";
import SearchIcon from "../../../resources/icons/SearchIcon";
import {concatenateQueryStrings, getQuerySearchParam, removeParam, serialize} from "../../../utils/converter";
import {useLocation, useNavigate} from "react-router-dom";

const InputSearch = ({
  defaultValue = "",
  cleanSearch = null,
  onSearch,
  autocomplete = true,
  hasMargin = true,
  length = 3,
  isDynamicSearch = false,
  extraClass = "",
  placeholder = "Search...",
}) => {
  const checkSearch = () => {
    const querySearch = getQuerySearchParam();
    if (querySearch) {
      return querySearch;
    }
    if (defaultValue) {
      return defaultValue;
    }
    return "";
  };

  const [search, setSearch] = useState(checkSearch());
  const [startCounter, setStartCounter] = useState(false);
  const inputRef = useRef(null);


  const location = useLocation();
  let navigate = useNavigate();


  useEffect(() => {
        if(isDynamicSearch){
            if(search.length === 0){
                navigate(removeParam('querySearch', location.pathname + location.search));
            }else{
                navigate(location.pathname + concatenateQueryStrings(location.search, serialize({querySearch: search})))
            }
        }
        // eslint-disable-next-line
  }, [isDynamicSearch, search]);

  useEffect(() => {
    if (cleanSearch !== null) {
      setSearch("");
      setStartCounter(true);
      if (inputRef.current) {
        inputRef.current.value = "";
      }
    }
  }, [cleanSearch]);

  const previousDefaultRef = useRef(defaultValue);

  useEffect(() => {
    if (defaultValue === undefined || defaultValue === null) {
      return;
    }

    if (previousDefaultRef.current === defaultValue) {
      return;
    }

    previousDefaultRef.current = defaultValue;
    setSearch(defaultValue);
    if (inputRef.current) {
      inputRef.current.value = defaultValue;
    }
  }, [defaultValue]);

  useEffect(() => {
    if (!startCounter) {
      return undefined;
    }

    if (search.length < length && search.length !== 0) {
      return undefined;
    }

    const timer = setTimeout(() => {
      if (typeof onSearch === "function") {
        onSearch(search);
      }
      setStartCounter(false);
    }, 400);

    return () => {
      clearTimeout(timer);
    };
  }, [startCounter, search, length, onSearch]);

  return (
    <div className={hasMargin ? "mt-1 relative rounded-md w-full sm:w-auto" : "relative rounded-md  w-full sm:w-auto "}>
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <SearchIcon className="h-5 w-5 text-blue-1000 " aria-hidden="true" />
      </div>
      <input
        type="search"
        name="search"
        id="search"
        autoComplete={autocomplete ? "on" : "off"}
        ref={inputRef}
        className={"form-search block w-full pl-10 "+extraClass}
        placeholder={placeholder}
        onChange={(e) => {
          setSearch(e.target.value);
          setStartCounter(true);
        }}
        defaultValue={search}
      />
    </div>
  );
};

export default InputSearch;
